import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass/styled-components';
import { Button } from '@getro/rombo';
import { trackEvent } from 'helpers/analytics';
import { RefreshContactModal } from 'components/molecules/refreshContactModal';

export const EnrichmentButton = ({ contact, networkId, isList }) => {
  const [showRefreshModal, setShowRefreshModal] = useState(false);

  if (!contact.linkedinUrl || !contact.linkedinUrl.match(/^https?:\/\/[^\s/$.?#].[^\s]*$/i)) {
    return null;
  }

  return (
    <>
      {showRefreshModal && (
        <RefreshContactModal
          onCloseModal={() => setShowRefreshModal(false)}
          linkedinUrl={contact.linkedinUrl}
          trackRefreshEvent={() => {
            trackEvent('contacts:refresh_profile_click', {
              collectionId: networkId,
              contactId: contact.id,
              linkedinHandle: contact?.linkedinHandle,
              page: isList ? 'list' : 'contacts',
              informationDaysOld: contact.enrichedProfileAgeInDays,
              experienceDaysOld: contact.enrichedExperienceAgeInDays,
              contactEnriched: contact.enrichmentStatus === 'enriched',
              experiencesCount: contact.contactWorkExperiences.length,
            });
          }}
        />
      )}
      <Flex sx={{ gap: '8px', flexDirection: 'column', alignItems: 'flex-start' }}>
        <Text sx={{ gridColumn: '1 / span 2', fontWeight: 400 }} fontSize="14px">
          We couldn’t enrich this contact automatically. The LinkedIn profile may be private or invalid.
        </Text>
        <Button
          onClick={(e) => {
            e.stopPropagation();
            setShowRefreshModal(true);
          }}
          size="small"
          variant="secondary"
          sx={{ flexShrink: 0 }}
        >
          Learn more
        </Button>
      </Flex>
    </>
  );
};

EnrichmentButton.propTypes = {
  contact: PropTypes.object.isRequired,
  networkId: PropTypes.string.isRequired,
  isList: PropTypes.bool.isRequired,
};
